import Button from 'components/Button'
import Control from 'components/Control/Control'
import AddIcon from 'components/icons/AddIcon'
import React, { useEffect, useState } from 'react'

import { Form } from 'antd'
import { setResumeData } from 'modules/Onboarding/actions'
import { SocialMedia } from 'modules/Resume/DrawerComponents/AdditionalDetails/AdditionInfoInput'
import {
  Heading,
  Text,
} from 'modules/Resume/DrawerComponents/AdditionalDetails/style'
import {
  AdjustIcon,
  FooterFlex,
  StyledDrawer,
} from 'modules/Resume/DrawerComponents/DrawerStyle'
import { useDispatch } from 'react-redux'
import ErrorMessage from 'utils/ErrorMessage'
import SuccessMessage from 'utils/SuccessMessage'

const SocialMediaDrawer = ({
  drawerStatus,
  setdrawerStatus,
  updateStudentData,
  studentFormData,
}) => {
  const [form] = Form.useForm()
  const dispatch = new useDispatch()
  const [isUpdateButtonEnabled, setIsUpdateButtonEnabled] = useState(true)

  const [socials, setSocials] = useState([
    {
      component: SocialMedia,
      type: 'socialmedia_0',
    },
  ])
  const [socilaMedia, setSocilaMedia] = useState([])
  const [socialMediaList, setSocialMediaList] = useState([])
  const [socialURLList, setSocialURLList] = useState([])

  useEffect(() => {
    let socialList = []
    studentFormData?.studentPersonalProfile?.socialMedia?.map((data, index) => {
      let type = 'socialmedia_' + index
      form.setFieldsValue({
        [type]: {
          media: data?.media,
          link: data?.link,
        },
      })
      socialList.push({
        component: SocialMedia,
        type: type,
      })
    })
    setSocials(
      studentFormData?.studentPersonalProfile?.socialMedia?.length > 0
        ? socialList
        : socials
    )
  }, [studentFormData])

  useEffect(() => {
    getSocailMediaList()
  }, [socials])

  const getSocailMediaList = () => {
    let socialmedia = getKeyValuePair('socialmedia')
    setSocilaMedia(Object.values(socialmedia))
    let medialList = []
    let linkList = []
    Object.entries(socialmedia).forEach(([key, value]) => {
      if (value?.media != null) {
        medialList.push([key, value?.media])
        linkList.push([key, value?.link])
      }
    })
    setSocialMediaList(medialList)
    setSocialURLList(linkList)
  }

  const getKeyValuePair = value => {
    let formObject = form.getFieldsValue()
    return Object.keys(formObject)
      .filter(key => key.includes(value))
      .reduce((cur, key) => {
        return Object.assign(cur, { [key]: formObject[key] })
      }, {})
  }

  const socialsHandler = (isAdd, isDelete, deleteVlaue) => {
    let arr = []
    arr.push({
      component: SocialMedia,
      type: 'socialmedia_' + socials?.length + 1,
    })
    if (isAdd) {
      setIsUpdateButtonEnabled(false)
      setSocials(so => so.concat(arr))
    }
    if (isDelete) {
      setIsUpdateButtonEnabled(false)
      let socialList = socials?.filter(data => data?.type !== deleteVlaue)
      setSocials(socialList)
      form.setFieldsValue({
        [deleteVlaue]: '',
      })
    }
  }

  const copyLinkHandler = value => {
    let copyText = form.getFieldValue([value])
    navigator.clipboard.writeText(copyText?.link)
    SuccessMessage('Link Copied')
  }
  const submitHandler = async values => {
    let payload = {
      admin: studentFormData?.admin,
      student: studentFormData?.student,
      degreeStreamMap: !studentFormData?.student?.isExpCandidate
        ? {
            degreeId: studentFormData?.currentCourse?.degreeId,
            streamId: studentFormData?.currentCourse?.streamId,
          }
        : {},
      studentPersonalProfile: {
        ...studentFormData?.studentPersonalProfile,

        socialMedia: socilaMedia || [],
      },
      currentCourse: !studentFormData?.student?.isExpCandidate
        ? {
            ...studentFormData?.currentCourse,
            marks: studentFormData?.currentCourse?.marks ?? 0,
          }
        : {},
      education: studentFormData?.education,
      resume: studentFormData?.resume,
    }
    if (payload?.currentCourse?.specialisationId === null) {
      delete payload?.currentCourse?.specialisationId
    }
    if (payload?.studentPersonalProfile?.secondaryEmail === null) {
      delete payload?.studentPersonalProfile?.secondaryEmail
    }
    studentFormData?.education.map((item, index) => {
      if (item?.skills === null) delete payload?.education[index]?.skills
      if (item?.degreeStreamMapId === null)
        delete payload?.education[index]?.degreeStreamMapId
    })
    if (payload?.currentCourse?.degreeStreamMapId === null) {
      delete payload?.currentCourse?.degreeStreamMapId
    }
    let response = await updateStudentData(payload)

    if (response?.success === true) {
      dispatch(setResumeData(payload))
      SuccessMessage('Additional details saved successfully!')
      setdrawerStatus(false)
    } else {
      ErrorMessage(response?.response?.data?.message)
    }
  }
  const content = () => {
    return (
      <Form
        scrollToFirstError
        id={'socialmediaForm'}
        onFinish={submitHandler}
        form={form}
        layout="vertical"
      >
        <Control top="10px">
          <Heading>Social Media</Heading>
        </Control>
        <Control column top="10px">
          {!!socials &&
            socials.map(obj => {
              return (
                <obj.component
                  key={obj}
                  type={obj?.type}
                  socialMediaList={socialMediaList}
                  socialURLList={socialURLList}
                  getSocailMediaList={getSocailMediaList}
                  setIsUpdateButtonEnabled={setIsUpdateButtonEnabled}
                  onRemove={() => socialsHandler(false, true, obj?.type)}
                  copyLink={() => copyLinkHandler(obj?.type)}
                />
              )
            })}
        </Control>
        <Control
          onClick={() => socialsHandler(true, false)}
          style={{ cursor: 'pointer' }}
          gap="10px"
          alignCenter
          width={'30%'}
        >
          <AdjustIcon>
            <AddIcon />
          </AdjustIcon>
          <Text>Add more links</Text>
        </Control>
      </Form>
    )
  }

  const footer = () => {
    return (
      <FooterFlex right>
        <Button.Secondary
          text="Cancel"
          onClick={() => {
            setdrawerStatus(false)
          }}
        />
        <Button.Primary
          form={'socialmediaForm'}
          htmlType="submit"
          text={'Update'}
          disabled={isUpdateButtonEnabled}
        />
      </FooterFlex>
    )
  }
  return (
    <StyledDrawer
      width="675px"
      title={'Social Media Links'}
      placement="right"
      closable={true}
      onClose={() => setdrawerStatus(false)}
      visible={drawerStatus}
      content={content()}
      footer={footer()}
    />
  )
}

export default SocialMediaDrawer
